import React, { useState } from "react";
import { Typography, Box, Button, Modal } from "@mui/material";
import CallBackModal from "../../component/Common/CallBackModal";
import { useSelector } from "react-redux";

const ContactUsSection = ({ handleSectionNavigation }) => {
  const supportNumber = useSelector(
    (state) => state.supportNumbers?.customerPortal
  );
  // State to control the visibility of the callback modal
  const [isCallBackModalOpen, setIsCallBackModalOpen] = useState(false);
  const number = useSelector((state) => state.supportNumbers?.landingPage);
  // Function to handle the "Reach Us" button click event
  const handleReachUsButtonClick = () => {
    setIsCallBackModalOpen(true);
  };

  /**
   * Closes the callback modal when called.
   */
  const closeCallBackModal = () => {
    setIsCallBackModalOpen(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        gap: { xs: "20px", md: "24px" },
        pt: { xs: "60px", md: "90px" },
        pb: { xs: "60px", md: "90px" },
        px: { xs: 2.5, md: 0 },
      }}
    >
      <Typography
        variant="h1"
        sx={{
          color: "#333",
          textAlign: "center",
          fontFamily: "Helvetica",
          fontSize: { xs: "2rem", md: "2.25rem" },
          fontWeight: 700,
        }}
      >
        Are you ready to accelerate your business?
      </Typography>

      <Typography
        variant="body1"
        sx={{
          color: "#4E4E4E",
          textAlign: "center",
          fontFamily: "Helvetica",
          fontSize: { xs: "1.0625rem", sm: "1.25rem", md: "1.5rem" },
          fontWeight: 400,
          maxWidth: "962px",
          px: { xs: 1, sm: 3, md: 0 },
        }}
      >
        Discover how we can boost your logistics
      </Typography>
      <Button
        variant="contained"
        onClick={() => handleSectionNavigation("home")}
        sx={{
          backgroundColor: "#0C7F44",
          color: "#FFF",
          textAlign: "center",
          fontFamily: "Helvetica",
          fontSize: { xs: "1.0625rem", sm: "1.25rem" },
          fontWeight: 700,
          width: { xs: "100%", sm: "auto" },
          maxWidth: "320px",
          py: { xs: 1.25, sm: 1.5 },
          "&:hover": { backgroundColor: "#0A6B39" },
        }}
      >
        BOOK YOUR TRUCK
      </Button>
      <Modal open={isCallBackModalOpen} onClose={closeCallBackModal}>
        <CallBackModal
          closeCallBackModal={closeCallBackModal}
          number={number}
        />
      </Modal>

      <Button
        variant="contained"
        sx={{
          backgroundColor: "#FFFFFF",
          color: "#000000",
          fontFamily: "Helvetica",
          fontSize: { xs: "1.0625rem", sm: "1.25rem" },
          fontWeight: 700,
          border: "2px solid #333",
          width: { xs: "100%", sm: "auto" },
          maxWidth: "320px",
          py: { xs: 1.25, sm: 1.5 },
          "&:hover": { backgroundColor: "#F5F5F5" },
        }}
        onClick={handleReachUsButtonClick}
      >
        Reach Us
      </Button>
    </Box>
  );
};

export default ContactUsSection;
